import React, { createRef, forwardRef, Fragment } from "react";
import { View, StyleSheet } from "react-native";
import ModalOverlay from "ae-base/Base/ModalOverlay";
import Signature from "react-native-signature-canvas";
import StyledButton from "../StyledButton";
import createUploadObj from "./createUploadObj";

import MobileLandscape from "./MobileLandscape";
import { useResources } from "@aetonix/hooks";

import html from "./html";

import StyledText from "../StyledText";
import Style from "ae-style";
const styles = StyleSheet.create({
	canvasContainer: {
		maxWidth: 1200,
		maxHeight: 500,
		width: "100%",
		height: "100%",
		flexDirection: "row"
	},
	submitWrapperStyle: { flexGrow: 1, flexDirection: "row", minWidth: 150 },
	submitStyle: { justifyContent: "center", flexGrow: 1 },
	container: { justifyContent: "center", alignItems: "center", flexGrow: 1 },
	centerText: { justifyContent: "center" },
	instructionText: { textAlign: "center", backgroundColor: "white", borderTopWidth: 2, borderColor: "black", borderStyle: "solid" },
	canvasError: { borderColor: Style.look.alert},
	signatureContainer: { flex: 1, borderRadius: 2, borderStyle: "solid", borderColor: "black" },
});

class SignaturePopupComp extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			showModal: false,
			confirmSignature: "",
			errorText: ""
		};

		this.openModal = this.openModal.bind(this);
		this.closeModal = this.closeModal.bind(this);
		this.onSign = this.onSign.bind(this);
		this.onConfirm = this.onConfirm.bind(this);
		this.cancelConfirm = this.cancelConfirm.bind(this);

		this.signatureRef = createRef();
		this.readSignature = this.readSignature.bind(this);
		this.clearSignature = this.clearSignature.bind(this);

		this.saveAndSubmit = this.saveAndSubmit.bind(this);

		this.setError = this.setError.bind(this);
		this.clearError = this.clearError.bind(this);
	}

	openModal() {
		const dispatch = this.props.dispatch;
		dispatch("usermetrics:trigger:track", "open signature page")();
		this.setState({ showModal: true, errorText: "" });
	}

	closeModal() {
		const dispatch = this.props.dispatch;
		if (this.state.confirmSignature) {
			dispatch("usermetrics:trigger:track", "cancel confirm signature")();
			this.cancelConfirm();
		} else {
			dispatch("usermetrics:trigger:track", "close signature page")();
			this.setState({ showModal: false });
		}
	}

	cancelConfirm() {
		const dispatch = this.props.dispatch;
		dispatch("usermetrics:trigger:track", "cancel signature confirmation page")();
		this.setState({ confirmSignature: "" });
	}
	onSign(base64) {
		if (typeof base64 === "string") {
			if (this.props.showConfirm) {
				this.setState({ confirmSignature: base64 });
			}
			else {
				this.saveAndSubmit(base64);
			}
		}
	}

	saveAndSubmit(base64) {
		const dispatch = this.props.dispatch;
		const { onDone = () => { } } = this.props;

		createUploadObj(base64).then((fileObj) => {
			onDone(fileObj, base64);
			dispatch("usermetrics:trigger:track", "save and submit signature")();
			this.setState({ showModal: false });
		});
	}

	onConfirm() {
		const dispatch = this.props.dispatch;
		dispatch("usermetrics:trigger:track", "confirm and submit signature")();
		this.saveAndSubmit(this.state.confirmSignature);
	}

	readSignature() {
		this.signatureRef.current.readSignature();
	}

	clearSignature() {
		const dispatch = this.props.dispatch;
		dispatch("usermetrics:trigger:track", "clear current signature")();
		this.signatureRef.current.clearSignature();
	}

	clearError() {
		this.setState({ errorText: "" });
	}

	setError(text) {
		return () => this.setState({ errorText: text });
	}

	render() {
		const localize = this.props.localize;

		const {
			backText = localize("signature.back"),
			submitText = localize("signature.submit"),
			clearText = localize("signature.clear")
		} = this.props;

		const emptyCanvasError = localize("signature.no_signature_error");

		const signAbove = localize("signature.sign_here");

		const instructionStyle = [styles.instructionText];

		if(this.state.errorText){
			instructionStyle.push(styles.canvasError);
		}
		return (
			<Fragment>
				{this.props.openComponent && this.props.openComponent(this.openModal)
				}

				{this.state.showModal && <ModalOverlay
					visible={this.state.showModal}
					onBackButtonPress={this.closeModal}
					onBackdropPress={this.closeModal}
				>
					<View style={styles.container}>
						<View style={[styles.canvasContainer]}>
							<View style={styles.signatureContainer}>
								<Signature onBegin={this.clearError} onOK={this.onSign} onEmpty={this.setError(emptyCanvasError)} trimWhitespace customHtml={html} ref={this.signatureRef} autoClear />
								<StyledText alert={!!this.state.errorText} black={!this.state.errorText} style={instructionStyle}>{this.state.errorText || signAbove}</StyledText>
							</View>
							<View>
								<StyledButton centered stretch title={backText} onPress={this.closeModal} style={styles.centerText}></StyledButton>
								<StyledButton centered stretch title={submitText} contrast onPress={this.readSignature} wrapperViewStyle={styles.submitWrapperStyle} style={styles.submitStyle}></StyledButton>
								<StyledButton centered stretch title={clearText} onPress={this.clearSignature} style={styles.centerText}></StyledButton>
							</View>
							<MobileLandscape isATouchAway={this.props.isATouchAway} />
						</View>
					</View>
				</ModalOverlay>}

			</Fragment>
		);
	}
}

const SignaturePopup = forwardRef(function SignaturePopup (props, ref) {
	const { localize, dispatch } = useResources();
	return <SignaturePopupComp {...props} localize={localize} dispatch={dispatch} ref={ref} />;
});
export default SignaturePopup;